import React from 'react';

import styled from '@emotion/styled';
import { PillBadge } from '@lightspeed/flame/Badge';
import { Box } from '@lightspeed/flame/Core';

type PillBadgeProps = {
  borderColor: string;
};

export const StyledPillBadge = styled(PillBadge)<PillBadgeProps>`
  border: 1px solid ${(props) => props.borderColor};
  justify-content: center;
  min-width: 100px;
  min-height: 24px;
  height: auto;
  width: auto;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0 !important;
  font-weight: 600;
  padding: 3px 12px;
  text-transform: none;
`;

export const InfoIcon = () => (
  <Box mt="4px" ml="4px">
    <img src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/devices/info-bold.svg" width={16} height={16} alt="Info icon" />
  </Box>
);
